/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time: Date | string | number, cFormat?: string) {
	if (arguments.length === 0 || !time) {
		return ""
	}
	const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
	let date

	if (typeof time === 'object') {
		date = time
	} else {
		if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
			// support "1548221490638"
			time = parseInt(time)
		}

		if ((typeof time === 'number') && (time.toString().length === 10)) {
			time = time * 1000
		}
		date = new Date(time)
	}

	const formatObj: Record<string, number> = {
		"y": date.getFullYear(),
		"m": date.getMonth() + 1,
		"d": date.getDate(),
		"h": date.getHours(),
		"i": date.getMinutes(),
		"s": date.getSeconds(),
		"a": date.getDay()
	}
	const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
		const value = formatObj[key]
		// Note: getDay() returns 0 on Sunday
		if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
		return value.toString().padStart(2, '0')
	})
	return time_str
}
/**
 * 获取两个日期相差天数
 * @param {(Date | string)} start
 * @param {(Date | string)} due
 * @returns {number}
 */
export function getDiffDay(start: Date | string, due: Date | string) {
	let startNum
	if (typeof start === 'string') {
		startNum = Date.parse(start)
	} else {
		startNum =start.getTime()
	}
	let dueNum
	if (typeof due === 'string') {
		dueNum = Date.parse(due)
	} else {
		dueNum = due.getTime()
	}
	let diff = dueNum - startNum
	diff = Math.abs(diff)
	diff = Math.floor(diff / (24 * 3600 * 1000))
	return diff
}
/**
 * @param {string} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time: string, option: string) {
	const d = new Date(time)
	const now = new Date()

	const diff = (now.getTime() - d.getTime()) / 1000

	if (diff < 30) {
		return '刚刚'
	} else if (diff < 3600) {
		// less 1 hour
		return Math.ceil(diff / 60) + '分钟前'
	} else if (diff < 3600 * 24) {
		return Math.ceil(diff / 3600) + '小时前'
	} else if (diff < 3600 * 24 * 2) {
		return '1天前'
	} else if (d.getFullYear() === now.getFullYear()) {
		return parseTime(d, "{m}-{d}")
	}
	if (option) {
		return parseTime(time, option)
	} else {
		return (
			d.getMonth() +
			1 +
			'月' +
			d.getDate() +
			'日' +
			d.getHours() +
			'时' +
			d.getMinutes() +
			'分'
		)
	}
}

export function isType(data: any, type: string): boolean {
	const typeObj: Record<string, string> = {
		'[object String]': 'string',
		'[object Number]': 'number',
		'[object Boolean]': 'boolean',
		'[object Null]': 'null',
		'[object Undefined]': 'undefined',
		'[object Object]': 'object',
		'[object Array]': 'array',
		'[object Function]': 'function',
		'[object Date]': 'date', // Object.prototype.toString.call(new Date())
		'[object RegExp]': 'regExp',
		'[object Map]': 'map',
		'[object Set]': 'set',
		'[object HTMLDivElement]': 'dom', // document.querySelector('#app')
		'[object WeakMap]': 'weakMap',
		'[object Window]': 'window',  // Object.prototype.toString.call(window)
		'[object Error]': 'error', // new Error('1')
		'[object Arguments]': 'arguments',
	}
	let name = Object.prototype.toString.call(data) // 借用Object.prototype.toString()获取数据类型
	let typeName = typeObj[name] || '未知类型' // 匹配数据类型
	return typeName === type // 判断该数据类型是否为传入的类型
}
export const getRandomColor = () => {
	return '#' + (Math.random() * 0xffffff << 0).toString(16);
}
export const toHsl = (value: string) => {
	return `hsl(${valueHash(value)}, 50%, 50%)`;
}

export const toHsla = (value: string, opacity: number) => {
	return `hsla(${valueHash(value)}, 50%, 50%, ${opacity}%)`;
}

export const valueHash = (value: string) => {
	let hash = 0;
	if (!value) return 0;
	for (let i = 0; i < value.length; i++) {
		hash = value.charCodeAt(i) + ((hash << 5) - hash);
	}

	return hash % 360;
}
export const base64ToFile = (base64: string, filename: string) => {
    let arr = base64.split(',');
    let mime = arr[0].match(/:(.*?);/)![1];
    let bstr = atob(arr[1]);
    let n = bstr.length;
    let u8arr = new Uint8Array(n);
    while(n--){
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, {type:mime});
}
export const isMobile = window.navigator && navigator.userAgent.match(
	/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
);